import React from "react";
import CHCHandleSubmitComponent from "./runtimeComponent/summary/CHCHandleSubmitComponent";
import HandleSubmitComponent from "./runtimeComponent/summary/HandleSubmitComponent";
import { CHCOrderConfirmationComponent } from "./runtimeComponent/summary/CHCOrderConfirmationComponent";
import { ProgramContainer } from "./entities/formTemplateDataType";
import APPHandleSubmitComponent from "./runtimeComponent/summary/APPHandleSubmitComponent";
import { APPOrderConfirmationComponent } from "./runtimeComponent/summary/APPOrderConfirmationComponent";
import ODRHandleSubmitComponent from "./runtimeComponent/summary/ODRHandleSubmitComponent";
import { ODROrderConfirmationComponent } from "./runtimeComponent/summary/ODROrderConfirmationComponent";
import VECONHandleSubmitComponent from "./runtimeComponent/summary/VECONHandleSubmitComponent";
import { VECONOrderConfirmationComponent } from "./runtimeComponent/summary/VECONOrderConfirmationComponent";
import EhocmAdminConfirmationComponent from "./runtimeComponent/summary/EhocmAdminConfirmationComponent";
import LibPubHandleSubmitComponent from "./runtimeComponent/summary/LibPubHandleSubmitComponent";

const componentsMap = {
    CHCSubmit: CHCHandleSubmitComponent,
    Submit: HandleSubmitComponent,
    CHCConfirmation: CHCOrderConfirmationComponent,
    APPSubmit: APPHandleSubmitComponent,
    APPConfirmation: APPOrderConfirmationComponent,
    ODRSubmit: ODRHandleSubmitComponent,
    ODRConfirmation: ODROrderConfirmationComponent,
    VECONSubmit: VECONHandleSubmitComponent,
    VECONConfirmation: VECONOrderConfirmationComponent,
    'ADMIN-PORTALConfirmation': EhocmAdminConfirmationComponent,
    LibraryPublicationSubmit: LibPubHandleSubmitComponent,
};

interface DynamicComponentProps {
  componentName: string; 
  componentProps: any; 
  onButtonClick?: (data) => void;
  callbackStepIndex?: (index: number, returnIndex?: number) => void;
  callback?: (p: ProgramContainer) => void;
}

const DynamicComponent: React.FC<DynamicComponentProps> = ({ componentName, componentProps, onButtonClick ,callbackStepIndex, callback}) => {
  const ComponentToRender = componentsMap[componentName];

  return <ComponentToRender {...componentProps} onButtonClick={onButtonClick} callbackStepIndex={callbackStepIndex} callback={callback}/>;
};

export default DynamicComponent;
